"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.enablePlugin = void 0;
var loadPlugins_1 = require("./loadPlugins");
var pluginStore_1 = require("./pluginStore");
function enablePlugin(pluginName, enabled) {
    pluginStore_1.updatePlugin(pluginName, function (plugin) { return (__assign(__assign({}, plugin), { enabled: enabled })); });
    loadPlugins_1.reloadPlugins();
}
exports.enablePlugin = enablePlugin;
